import axios from 'axios';
import {
  I360MemberList,
  I360MemberListV2,
  IContent,
  IGetSurveyMemberList,
  IMemberGroupDetail,
  ISurveyGroupAddList,
  ISurveyMemberAddList,
} from 'views/pages/survey/surveyAdd/ListOfMembers/types';
import {
  ICheckSurveyResults,
  ICheckSurveyResultsParams,
  IDDLCategory,
  IEmbedApps,
  IGetCustomer,
  IGetInfoClient,
  IGetSurveyInfomation,
  ICopySurveyParams,
  IGroupQuestion,
  ILinkSurveyQuestionsResponse,
  IResultAnalysis,
  ISetSurveyInfomation,
  ISubmitSurveyResponse,
  ISurveyAddQuestion,
  ISurveyContent,
  ISurveyDepartment,
  ISurveyLevel,
  ISurveyPosition,
  ISurveyQuestions,
  ISurveyResults,
  ISurveyStaff,
  ISurveyStaffProps,
  ISurveyTotalStatistics,
  ISurveyUnit,
  ISurveyUser,
  ICategoryDetail,
  ISurveyStaff360,
  ISurveyStaffParamsAPI,
  I360MemberListParamsAPI,
  IAddSurveyStaff360Response,
  IUpdateSurveyStaff360Response,
  ISurveyViewers,
  IDepartment,
  ISurvey360Objects,
  IApps,
  IParamFilterEvaluatedQuestionProps,
  IMemberAnalysis,
  IGetUserOtherSurveyResponse,
} from 'views/pages/survey/surveyAdd/type';
import {
  ICheckFileBeforeUpload,
  IList,
  IRequestSearch,
  IRequestGetSurveyByID,
  ICheckFileStaffBeforeUploadNormal,
  IRequestDeleteStaffAssignedBySurvey,
} from 'views/pages/survey/type';
import { IDataSubmitSurvey } from 'views/pages/surveyList/previewSurveyDevice/types';
import ApiClient from './ApiClient';
import { handleGetUSerID } from 'utils/helperFunctions';

export const getSurveyApi = async (
  params: IRequestSearch,
  userIdView: string,
  userGroup: string
): Promise<IList> => {
  const { data } = await ApiClient.postJsonData(
    '/Survey/getSurveys',
    {
      userIdView,
      userGroup,
    },
    { ...params }
  );
  return data;
};
export const getDetailSurveyApi = async (
  params: IRequestGetSurveyByID
): Promise<IGetSurveyInfomation> => {
  const { data } = await ApiClient.getNoHeader('/Survey/getSurveyByID', {
    ...params,
  });
  return data;
};
export const getDetailMemberListApi = async (SurveyId: string): Promise<IGetSurveyMemberList[]> => {
  const { data } = await ApiClient.get('/Survey/getSurveyPeople', { surveyID: SurveyId });
  return data;
};

export const get360SurveyMembersListApi = async ({
  page,
  pageSize,
  surveyID,
}: {
  page: number;
  pageSize: number;
  surveyID: string;
}): Promise<I360MemberListV2> => {
  const { data } = await ApiClient.postJsonData(
    '/Survey/get360SurveyMembers',
    {},
    { page, pageSize, surveyID }
  );
  return data;
};
export const getDetailGroupApi = async (SurveyId: string): Promise<IMemberGroupDetail> => {
  const { data } = await ApiClient.get('/Survey/getSurveyGroupsByID', { surveyID: SurveyId });
  return data;
};
export const getDDLGroupQuestionApi = async (): Promise<IGroupQuestion[]> => {
  const { data } = await ApiClient.get('/DropDownList/ddlQuestionGroup', {}, {});
  return data;
};

export const getDDLResultUserApi = async (): Promise<ISurveyUser[]> => {
  const { data } = await ApiClient.get('/DropDownList/ddlUser', {}, {});
  return data;
};
export const getDDLResultLevelApi = async (): Promise<ISurveyLevel[]> => {
  const { data } = await ApiClient.get('/DropDownList/ddllevel', {}, {});
  return data;
};

export const getDDLResultUnitApi = async (): Promise<ISurveyUnit[]> => {
  const { data } = await ApiClient.postJsonData('/DropDownList/ddlUnit', {}, []);
  return data;
};
export const getDDLResultDepartmentApi = async (): Promise<ISurveyDepartment[]> => {
  const { data } = await ApiClient.postJsonData('/DropDownList/ddlDepartment', {}, []);
  return data;
};
export const getDdlEmbedAppApi = async (): Promise<IEmbedApps[]> => {
  const { data } = await ApiClient.get('/DropDownList/ddlApp', {}, {});
  return data;
};
export const getDDLResultPositionApi = async (): Promise<ISurveyPosition[]> => {
  const { data } = await ApiClient.get('/DropDownList/ddlposition', {}, {});
  return data;
};
export const postDDLResultStaffApi = async ({
  page = 1,
  pageSize = 20,
  keyWord = '',
  units = [],
  departments = [],
  positions = [],
  levels = [],
  survey360Objects = [],
  regions = [],
  divisions = [],
  restaurants = [],
  type = true,
  surveyId = '',
}: Partial<ISurveyStaffProps>): Promise<ISurveyStaff[]> => {
  const { data } = await ApiClient.postJsonDataNoHeader(
    '/DropDownList/ddlStaff',
    {},
    {
      page,
      pageSize,
      keyWord,
      units,
      departments,
      positions,
      levels,
      survey360Objects,
      regions,
      divisions,
      restaurants,
      type,
    }
  );
  return data;
};
export const postSurveyInformationApi = async (
  params: ISetSurveyInfomation
): Promise<IGetSurveyInfomation> => {
  const { data } = await ApiClient.postJsonData('/Survey/addSurvey', {}, { ...params });
  return data;
};

export const updateSurveyInfomationApi = async (
  params: ISetSurveyInfomation
): Promise<IGetSurveyInfomation> => {
  const userID = handleGetUSerID();
  const { data } = await ApiClient.putJsonData(
    '/Survey/updateSurvey',
    { userIdUpdate: userID },
    { ...params }
  );
  return data;
};

export const postSurveyAddQuestionApi = async (
  params: ISurveyAddQuestion
): Promise<ISurveyContent> => {
  const { data } = await ApiClient.postJsonData('/Survey/addSurveyQuestions', {}, { ...params });
  return data;
};

export const updateSurveyAddQuestionApi = async (
  params: ISurveyAddQuestion
): Promise<ISurveyContent> => {
  const { data } = await ApiClient.putJsonData('/Survey/updateSurveyQuestions', {}, { ...params });
  return data;
};

export const postSurveyMemberListUserApi = async (param: ISurveyMemberAddList): Promise<any> => {
  const { data } = await ApiClient.postJsonData('/Survey/addSurveyStaffs', {}, { ...param });
  return data;
};
export const updateSurveyMemberListUserApi = async (param: ISurveyMemberAddList): Promise<any> => {
  const { data } = await ApiClient.putJsonData('/Survey/updateSurveyStaffs', {}, { ...param });
  return data;
};
export const updateSurveyMemberListGroupApi = async (param: ISurveyGroupAddList): Promise<any> => {
  const { data } = await ApiClient.putJsonData('/Survey/updateSurveyGroups', {}, { ...param });
  return data;
};

export const updateSurveyMemberListAllCompanyApi = async (param: {
  surveyID: string;
}): Promise<any> => {
  const { data } = await ApiClient.putJsonData('/Survey/updateSurveyAllObject', { ...param }, {});
  return data;
};

export const postSurveyMemberListAllCompanyApi = async (param: {
  surveyID: string;
}): Promise<any> => {
  const { data } = await ApiClient.postJsonData('/Survey/addSurveyAllObject', { ...param }, {});
  return data;
};

export const postSurveyMemberListGroupApi = async (param: ISurveyGroupAddList): Promise<any> => {
  const { data } = await ApiClient.postJsonData('/Survey/addSurveyGroups', {}, { ...param });
  return data;
};

export const uploadFileUserApi = async (SurveyId: string, formData: any) => {
  const { data } = await ApiClient.uploadFileExcelPostMutipartData(
    '/Survey/importPersonal',
    { surveyID: SurveyId },
    formData
  );
  return data;
};

export const postSurveyStaffs = async (
  params: I360MemberListParamsAPI
): Promise<I360MemberList> => {
  const { data } = await ApiClient.postJsonData('/Survey/getStaffs', {}, params);
  return data;
};

export const postSurveyCustomers = async (params: IGetCustomer): Promise<any> => {
  const { data } = await ApiClient.postJsonData('/Survey/getCustomers', {}, { ...params });
  return data;
};

export const getNumberPeopleDoNotSurvey = async (SurveyId: string): Promise<number> => {
  const { data } = await ApiClient.get(
    '/Survey/getNumberPeopleDoNotSurvey',
    { surveyID: SurveyId },
    {}
  );
  return data;
};

export const updateSurveyStatus = async (SurveyId: string, Status: number): Promise<number> => {
  const { data } = await ApiClient.putJsonData(
    '/Survey/updateSurveyStatus',
    { surveyID: SurveyId, surveyStatus: Status },
    {}
  );
  return data;
};

export const exportPeopleDoNotSurvey = async (
  fileName: string,
  SurveyId: string
): Promise<boolean> => {
  const { data } = await ApiClient.downloadExcelGet(
    '/Survey/exportPeopleDoNotSurvey',
    {},
    {
      surveyID: SurveyId,
    },
    fileName
  );
  return data;
};

export const exportSurveyPeople = async (fileName: string, SurveyId: string): Promise<boolean> => {
  const { data } = await ApiClient.downloadExcelGet(
    '/Survey/exportSurveyPeople',
    {},
    {
      surveyID: SurveyId,
    },
    fileName
  );
  return data;
};

/** SurveyResults */

export const getSurveyTotalStatistics = async (
  SurveyId: string
): Promise<ISurveyTotalStatistics> => {
  const { data } = await ApiClient.get(
    '/SurveyResults/getSurveyStatistics',
    {},
    {
      surveyID: SurveyId,
    }
  );
  return data;
};

export const getSurveyResults = async (SurveyId: string): Promise<ISurveyResults> => {
  const { data } = await ApiClient.getNoHeader(
    '/SurveyResults/getSurveyResults',
    {
      surveyID: SurveyId,
    },
    {}
  );
  return data;
};

export const getSurveyResultsWithLogin = async (SurveyId: string): Promise<ISurveyResults> => {
  const { data } = await ApiClient.get(
    '/SurveyResults/getSurveyResultsWithLogin',
    {
      surveyID: SurveyId,
    },
    {}
  );
  return data;
};

/**SMS */
export const sendSMSSurvey = async (surveyID: string, userIdRequest: string) => {
  const { data } = await ApiClient.get(
    '/Survey/sendSMSSurvey',
    {},
    {
      surveyID,
      userIdRequest,
    }
  );
  return data;
};

/**Link Survey */
export const getLinkSurvey = async (
  surveyID: string,
  conditionID: string
): Promise<ILinkSurveyQuestionsResponse> => {
  const { data } = await ApiClient.getNoHeader(
    '/Survey/getLinkSurvey',
    {
      surveyID,
      conditionID,
    },
    {}
  );
  return data;
};

export const getLinkSurveyWithLogin = async (
  surveyID: string,
  conditionID: string
): Promise<ILinkSurveyQuestionsResponse> => {
  const { data } = await ApiClient.get(
    '/Survey/getLinkSurveyWithLogin',
    {
      surveyID,
    },
    {}
  );
  return data;
};

export const checkSurveyResults = async (
  params: ICheckSurveyResultsParams
): Promise<ICheckSurveyResults> => {
  const { data } = await ApiClient.postJsonDataNoHeader(
    '/SurveyResults/checkSurveyResults',
    {},
    {
      ...params,
    }
  );
  return data;
};

export const checkSurveyResultsWithLogin = async (
  params: ICheckSurveyResultsParams
): Promise<ICheckSurveyResults> => {
  const { data } = await ApiClient.postJsonData(
    '/SurveyResults/checkSurveyResultsWithLogin',
    {},
    {
      ...params,
    }
  );
  return data;
};

export const createLinkSurvey = async (SurveyId: string): Promise<string> => {
  const { data } = await ApiClient.get(
    '/Survey/createLinkSurvey',
    {
      surveyID: SurveyId,
    },
    {}
  );
  return data;
};

/**Get Survey Question */
export const getSurveyQuestionByID = async (SurveyId: string): Promise<ISurveyQuestions[]> => {
  const { data } = await ApiClient.get(
    '/Survey/getSurveyQuestionsByID',
    {
      surveyID: SurveyId,
    },
    {}
  );
  return data;
};

/**Delete Survey */
export const deleteSurveyById = async (SurveyId: string): Promise<any> => {
  const params = {
    SurveyId,
  };
  const response = await ApiClient.delete('/Survey/deleteSurvey', params);
  return response.data;
};
/**Submit Survey */
export const SubmitSurvey = async (params: IDataSubmitSurvey): Promise<ISubmitSurveyResponse> => {
  const response = await ApiClient.postJsonDataNoHeader(
    '/Survey/addPeopleSurveyResultsV2',
    {},
    { ...params }
  );
  return response;
};

export const SubmitSurveyWithLogin = async (
  params: IDataSubmitSurvey
): Promise<ISubmitSurveyResponse> => {
  const response = await ApiClient.postJsonData(
    '/Survey/addPeopleSurveyResultsWithLogin',
    {},
    { ...params }
  );
  return response;
};

export const getInfoClient = async (): Promise<IGetInfoClient> => {
  const { data } = await axios.get('https://geolocation-db.com/json/');
  return data;
};

/**Copy Survey */
export const copySurvey = async (params: ICopySurveyParams): Promise<IGetSurveyInfomation> => {
  const { data } = await ApiClient.get('/Survey/copySurvey', { ...params }, {});
  return data;
};

/** Survey Result Export Excel Related API */
export const uploadFileForSurveyResultAnalysis = async (
  SurveyId: string,
  formData: FormData,
  option: any
) => {
  const { data } = await ApiClient.uploadFileExcelPostMutipartData(
    '/SurveyResults/uploadSurveyResultsAnalysis',
    { surveyID: SurveyId },
    formData,
    option
  );
  return data;
};

export const uploadFileForSurveyMemberAnalysis = async (
  SurveyId: string,
  formData: FormData,
  option: any
) => {
  const { data } = await ApiClient.uploadFileExcelPostMutipartData(
    '/Survey/saveFileSurvey',
    { surveyID: SurveyId },
    formData,
    option
  );
  return data;
};

export const getSurveyResultAnalysis = async (SurveyId: string): Promise<IResultAnalysis[]> => {
  const { data } = await ApiClient.get(
    '/SurveyResults/getSurveyResultsAnalysis',
    {
      surveyID: SurveyId,
    },
    {}
  );
  return data;
};
export const getSurveyMemberAnalysis = async (SurveyId: string): Promise<IMemberAnalysis> => {
  const { data } = await ApiClient.get(
    '/Survey/getFileSurvey',
    {
      surveyID: SurveyId,
    },
    {}
  );
  return data;
};

export const deleteMemberAnalysisApi = async (surveyID: string, idFile: string): Promise<any> => {
  const params = {
    surveyID,
    idFile,
  };
  const response = await ApiClient.delete('/Survey/deleteFileSurvey', params);
  return response.data;
};

export const exportSurveyResultAnalysis = async (
  fileName: string,
  SurveyId: string
): Promise<boolean> => {
  const { data } = await ApiClient.downloadExcelGet(
    '/SurveyResults/downloadSurveyResultsAnalysis',
    {},
    {
      surveyID: SurveyId,
      nameFile: fileName,
    },
    fileName
  );
  return data;
};

export const exportSurveyMemberAnalysis = async (
  idFile: string,
  fileName: string,
  SurveyId: string
): Promise<boolean> => {
  const { data } = await ApiClient.downloadExcelPost(
    '/Survey/dowloadFileSurvey',
    {
      surveyID: SurveyId,
      idFile: idFile,
    },
    {},
    fileName
  );
  return data;
};

export const checkFileBeforeUploadQuestionInSurvey = async (
  formData: FormData,
  SurveyId: string
): Promise<ICheckFileBeforeUpload[]> => {
  const { data } = await ApiClient.uploadFileExcelPostMutipartData(
    '/Survey/checkQuestionUpload',
    { surveyID: SurveyId },
    formData
  );
  return data;
};

export const uploadSurveyQuestionsApi = async (
  formData: FormData,
  option: any,
  SurveyId: string,
  dataFromAPI?: any
) => {
  formData.append('jsonSheet', dataFromAPI ? JSON.stringify(dataFromAPI) : '');
  const { data } = await ApiClient.uploadFileExcelPostMutipartData(
    '/Survey/questionSurveyUpload',
    { surveyID: SurveyId },
    formData,
    option
  );
  return data;
};

export const uploadEvaluatedPeopleApi = async (formData: any, option: any) => {
  const { data } = await ApiClient.uploadFileExcelPostMutipartData(
    '/Survey/uploadPersonEvaluated',
    {},
    formData,
    option
  );
  return data;
};

export const exportSurveyResults = async (fileName: string, SurveyId: string): Promise<boolean> => {
  const { data } = await ApiClient.downloadExcelGet(
    '/SurveyResults/exportSurveyResults',
    {},
    {
      surveyID: SurveyId,
    },
    fileName
  );
  return data;
};

export const exportSurvey360Results = async (
  fileName: string,
  SurveyId: string
): Promise<boolean> => {
  const { data } = await ApiClient.downloadExcelGetXlsm(
    '/SurveyResults/exportSurveyResultsType360',
    {},
    {
      surveyID: SurveyId,
    },
    fileName
  );
  return data;
};

export const getDDLCategoryApi = async (type: number): Promise<IDDLCategory[]> => {
  const { data } = await ApiClient.get('/DropDownList/ddlCategory', { type });
  return data;
};

export const getCategoryDetailApi = async (params: ICategoryDetail): Promise<IDDLCategory[]> => {
  const { data } = await ApiClient.postJsonData('/Survey/getCategoryDetail', {}, { ...params });
  return data;
};

export const getSurvey360StaffsApi = async (surveyID: string): Promise<IDDLCategory[]> => {
  const { data } = await ApiClient.get('/Survey/getSurvey360Staffs', { surveyID });
  return data;
};

export const uploadFileStaffApi = async (
  formData: any,
  option: any,
  SurveyId: string,
  pageSize: number
) => {
  const params = {
    surveyID: SurveyId,
    pageSize: pageSize,
  };
  const { data } = await ApiClient.uploadFileExcelPostMutipartData(
    '/Survey/uploadFileStaff',
    params,
    formData,
    option
  );
  return data;
};

export const checkFileBeforeUploadStaff = async (
  formData: FormData,
  SurveyId: string
): Promise<ICheckFileBeforeUpload[]> => {
  const { data } = await ApiClient.uploadFileExcelPostMutipartData(
    '/Survey/checkUploadFileStaff',
    { surveyID: SurveyId },
    formData
  );
  return data;
};

export const checkFileBeforeUploadEvaluatedPeople = async (
  formData: FormData,
  SurveyId: string
): Promise<ICheckFileBeforeUpload[]> => {
  const { data } = await ApiClient.uploadFileExcelPostMutipartData(
    '/Survey/checkUploadPersonEvaluated',
    { surveyID: SurveyId },
    formData
  );
  return data;
};

export const checkFileBeforeUploadStaffNormal = async (
  formData: FormData,
  surveyID: string
): Promise<ICheckFileStaffBeforeUploadNormal[]> => {
  const { data } = await ApiClient.uploadFileExcelPostMutipartData(
    '/Survey/checkImportPersonal',
    { surveyID },
    formData
  );

  return data;
};

export const addSurvey360StaffsApi = async (
  params: ISurveyStaffParamsAPI
): Promise<IAddSurveyStaff360Response> => {
  const { data } = await ApiClient.postJsonData('/Survey/addSurvey360Staffs', {}, { ...params });
  return data;
};
export const updateSurvey360StaffsApi = async (
  params: ISurveyStaffParamsAPI
): Promise<IUpdateSurveyStaff360Response> => {
  const { data } = await ApiClient.putJsonData('/Survey/updateSurvey360Staffs', {}, { ...params });
  return data;
};

export const deleteMemberByIdApi = async (surveyID: string, conditionID: string): Promise<any> => {
  const params = {
    surveyID,
    conditionID,
  };
  const response = await ApiClient.delete('/Survey/deleteStaffBySurvey', params);
  return response.data;
};

export const deleteStaffAssignedBySurveyApi = async (
  params: IRequestDeleteStaffAssignedBySurvey
): Promise<any> => {
  const { data } = await ApiClient.delete('/Survey/deleteStaffAssingedBySurvey', params);
  return data;
};

export const checkSurveyReady = async (surveyID: string): Promise<boolean> => {
  const { data } = await ApiClient.get('/Survey/checkSurveyReady', { surveyID });
  return data;
};

export const getInformationSurvey = async (
  params: IRequestGetSurveyByID
): Promise<IGetSurveyInfomation> => {
  const { data } = await ApiClient.getNoHeader('/Survey/getInfoSurvey', params);
  return data;
};

export const getInformationSurveyWithLogin = async (
  params: IRequestGetSurveyByID
): Promise<IGetSurveyInfomation> => {
  const { data } = await ApiClient.get('/Survey/getInfoSurveyWithLogin', params);
  return data;
};

export const getSurveyViewers = async (surveyID: string): Promise<ISurveyViewers[]> => {
  const { data } = await ApiClient.get('/Survey/getSurveyViewers', {
    surveyID,
  });
  return data;
};

export const getSurveyDepartments = async (surveyID: string): Promise<IDepartment[]> => {
  const { data } = await ApiClient.get('/Survey/getSurveyDepartments', {
    surveyID,
  });
  return data;
};

export const getSurveyObject360 = async (surveyID: string): Promise<ISurvey360Objects[]> => {
  const { data } = await ApiClient.get('/Survey/getSurveyObject360', {
    surveyID,
  });
  return data;
};

export const getSurveyApps = async (surveyID: string): Promise<IApps[]> => {
  const { data } = await ApiClient.get('/Survey/getSurveyApps', {
    surveyID,
  });
  return data;
};

export const getFilterSurvey = async (
  surveyID: string
): Promise<IParamFilterEvaluatedQuestionProps> => {
  const { data } = await ApiClient.get('/Survey/getFilterSurvey', {
    surveyID,
  });
  return data;
};

export const getUserOtherSurvey = async (params: {
  email: string;
  phone: string;
  userID: string;
}): Promise<IGetUserOtherSurveyResponse[]> => {
  const { data } = await ApiClient.get('/SurveyResults/GetUserOtherSurvey', params);
  return data;
};

export const getUserOtherSurveyNoCache = async (params: {
  email: string;
  phone: string;
  userID: string;
}): Promise<IGetUserOtherSurveyResponse[]> => {
  const { data } = await ApiClient.getCustomHeader(
    '/SurveyResults/GetUserOtherSurvey',
    params,
    undefined,
    {
      'Cache-Control': 'no-cache, no-store, max-age=0, must-revalidate',
      Pragma: 'no-cache',
      Expires: '0',
    }
  );
  return data;
};

export const postDDLSearchStaffApi = async ({
  page = 1,
  pageSize = 20,
  keyWord = '',
  units = [],
  departments = [],
  positions = [],
  levels = [],
  survey360Objects = [],
  regions = [],
  divisions = [],
  restaurants = [],
  type = true,
  surveyId = '',
  controller = undefined,
}: Partial<ISurveyStaffProps>): Promise<ISurveyStaff[]> => {
  const { data } = await ApiClient.postJsonDataNoHeader(
    '/DropDownList/ddlFilteredStaff',
    {},
    {
      page,
      pageSize,
      keyWord,
      units,
      departments,
      positions,
      levels,
      survey360Objects,
      regions,
      divisions,
      restaurants,
      type,
    },
    { ...(controller ? { signal: controller?.signal } : {}) }
  );
  return data;
};
